import { Link as RouterLink } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import { Link } from '@mui/material'
import { Logo } from '../Logo/Logo'
import { SidebarDrawer } from '../Sidebar/SidebarDrawer'
import { Path } from '../../types/Path'
import { useContext } from 'react'
import { LayoutContext } from '../../contexts/LayoutContext'
import { ProfileContext, ThemeVariation } from '../../contexts/ProfileContext'

export interface HeaderProps {
  listItems: Path[]
}

export const Header = ({ listItems }: HeaderProps) => {
  const { sidebar } = useContext(LayoutContext)
  const { theme } = useContext(ProfileContext)

  return (
    <AppBar
      position='fixed'
      sx={{
        height: '3rem',
        width: { xs: '100%', md: '15rem' },
        bgcolor: { xs: 'primary.main', md: 'background.paper' },
        left: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      elevation={0}
    >
      <Toolbar sx={{ px: 4 }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            width: '15rem',
            alignItems: 'center',
            pt: '0.5rem',
            bgcolor: 'background.paper',
          }}
        >
          <Link component={RouterLink} to={'/'}>
            <Logo
              width='164px'
              height='68px'
              color={theme === ThemeVariation.Dark ? '#fff' : '#424F76'}
            />
          </Link>
        </Box>

        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            size='large'
            aria-label='account of current user'
            aria-controls='menu-appbar'
            aria-haspopup='true'
            onClick={sidebar.toggle}
            color='inherit'
          >
            <MenuIcon />
          </IconButton>
          <SidebarDrawer listItems={listItems} />
        </Box>

        <Box
          sx={{
            display: { xs: 'flex', md: 'none' },
            flexGrow: 1,
          }}
        >
          <Link component={RouterLink} to={'/'} display='flex'>
            <Logo width='98px' height='32px' color='#FFF' />
          </Link>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'row',
            ml: 6,
          }}
        />
      </Toolbar>
    </AppBar>
  )
}
